module.exports = __webpack_public_path__ + "img/vip_fukuanshenqing.ff985199.png";